
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("go76J", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $5kjCz = parcelRequire("5kjCz");


var $JbVPK = parcelRequire("JbVPK");


var $bX5uj = parcelRequire("bX5uj");


var $ep3mz = parcelRequire("ep3mz");


var $dJsIz = parcelRequire("dJsIz");





var $jMyy4 = parcelRequire("jMyy4");


var $fUCKK = parcelRequire("fUCKK");

/**
 * Shared helpers for building attachment download URLs.
 * Used by AttachmentsTable and VersionHistory.
 */ /**
 * Strip an ARI prefix to get the bare numeric content ID.
 * e.g. "ari:cloud:confluence::content/12345" → "12345"
 */ const $938f1daee99da6d8$export$839894812e415e90 = (id)=>{
    const lastSlash = id.lastIndexOf('/');
    return lastSlash >= 0 ? id.slice(lastSlash + 1) : id;
};
const $938f1daee99da6d8$export$294caf8e77e086a1 = (pageId, fileName, version)=>{
    if (typeof window === 'undefined') return '';
    const base = `${window.location.origin}/wiki/download/attachments/${pageId}/${encodeURIComponent(fileName)}`;
    return version ? `${base}?version=${version}` : base;
};
const $938f1daee99da6d8$export$94bf3d6a75159b3c = (downloadPath)=>{
    if (typeof window === 'undefined') return '';
    return `${window.location.origin}/wiki${downloadPath}`;
};
const $938f1daee99da6d8$export$ab3bbcca4ee23e63 = (pageId, fileName, version, downloadPath)=>pageId ? $938f1daee99da6d8$export$294caf8e77e086a1(pageId, fileName, version) : $938f1daee99da6d8$export$94bf3d6a75159b3c(downloadPath);


// Flatten raw GraphQL attachment nodes into clean AttachmentItem objects
// so the UI doesn't have to deal with nested fragments/extensions.
// Turn the raw operations[] array into boolean permission flags.
// delete → canDelete, update → canEdit, read → canPreview + canView.
const $ccf18cfc0e72a10f$export$10eb4f54a3859f60 = (ops)=>{
    const has = (op)=>!!ops?.some((o)=>o?.operation === op);
    return {
        hasDeletePermission: has('delete'),
        hasEditPermission: has('update'),
        hasPreviewPermission: has('read'),
        hasViewPermission: has('read')
    };
};



var $bUIlA = parcelRequire("bUIlA");

const $cfd67d8c6a811bce$var$UNKNOWN_USER = {
    displayName: '',
    accountId: '',
    profilePicture: {
        path: ''
    }
};
// Convert raw Person → AttachmentUser. Returns empty user for anonymous.
const $cfd67d8c6a811bce$var$normalizeUser = (raw)=>{
    if (!raw) return $cfd67d8c6a811bce$var$UNKNOWN_USER;
    return {
        displayName: raw.displayName ?? '',
        accountId: raw.accountId ?? '',
        profilePicture: {
            path: raw.profilePicture?.path ?? ''
        }
    };
};
// Strip `?version=N` for a stable "latest version" download path.
const $cfd67d8c6a811bce$var$stripVersionParam = (downloadPath)=>{
    const idx = downloadPath.indexOf('?version=');
    return idx >= 0 ? downloadPath.slice(0, idx) : downloadPath;
};
const $cfd67d8c6a811bce$export$6f29ddb57f342c25 = (raw)=>{
    if (!raw || !raw.id || !raw.title) return null;
    const fileSize = Number((0, $bUIlA.getExtensionValue)(raw.extensions, 'fileSize') ?? 0);
    const mediaType = (0, $bUIlA.getExtensionValue)(raw.extensions, 'mediaType') ?? '';
    const fileId = (0, $bUIlA.getExtensionValue)(raw.extensions, 'fileId') ?? '';
    const downloadPath = raw.links?.download ?? '';
    const downloadPathWithoutVersion = $cfd67d8c6a811bce$var$stripVersionParam(downloadPath);
    const lastModificationDate = raw.version?.when ?? '';
    const lastModifier = $cfd67d8c6a811bce$var$normalizeUser(raw.version?.by ?? null);
    const creationDate = raw.history?.createdDate ?? '';
    const creator = $cfd67d8c6a811bce$var$normalizeUser(raw.history?.createdBy ?? null);
    const labels = raw.labels?.nodes?.flatMap((label)=>label?.name ? [
            label.name
        ] : []) ?? [];
    const permissions = (0, $ccf18cfc0e72a10f$export$10eb4f54a3859f60)(raw.operations);
    return {
        id: raw.id,
        fileId: fileId,
        fileName: raw.title,
        mediaType: mediaType,
        fileSize: fileSize,
        downloadPath: downloadPath,
        downloadPathWithoutVersion: downloadPathWithoutVersion,
        lastModificationDate: lastModificationDate,
        lastModifier: lastModifier,
        creationDate: creationDate,
        creator: creator,
        versionComment: raw.version?.message ?? '',
        version: raw.version?.number ?? 1,
        labels: labels,
        ...permissions
    };
};


/**
 * @generated SignedSource<<361d9ccfaabef07bb33285e817b021c7>>
 * @relayHash d2c17d59c8b0db375d09de389758b5b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3fc06d516d07fef8febde1364330bb0ee5d56613b1eb590ac5085c601a8ad5b6
const $d4df523b7f0aeb37$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": 250,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": 0,
            "kind": "LocalArgument",
            "name": "offset"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "current",
                "draft",
                "archived"
            ]
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            }
        ]
    }, v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "offset",
            "variableName": "offset"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "count"
    }, v6 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "title"
    }, v8 = {
        "kind": "ScalarField",
        "name": "type"
    }, v9 = {
        "concreteType": "KeyValueHierarchyMap",
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "number"
    }, v11 = {
        "kind": "ScalarField",
        "name": "when"
    }, v12 = {
        "kind": "ScalarField",
        "name": "message"
    }, v13 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ ,
            v14 /*: any*/ ,
            {
                "concreteType": "Icon",
                "kind": "LinkedField",
                "name": "profilePicture",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "path"
                    }
                ]
            }
        ],
        "type": "KnownUser"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ],
        "type": "UnknownUser"
    }, v17 = [
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ], v18 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v19 = {
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 100
            }
        ],
        "concreteType": "PaginatedLabelList",
        "kind": "LinkedField",
        "name": "labels",
        "plural": false,
        "selections": [
            {
                "concreteType": "Label",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    }
                ]
            }
        ],
        "storageKey": "labels(first:100)"
    }, v20 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "download"
            }
        ]
    }, v21 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAttachmentsMacroDataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "PaginatedContentList",
                            "kind": "LinkedField",
                            "name": "attachments",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": v17 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v17 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v19 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAttachmentsMacroDataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "PaginatedContentList",
                            "kind": "LinkedField",
                            "name": "attachments",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": v21 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v21 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v19 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "d2c17d59c8b0db375d09de389758b5b4",
            "id": "3fc06d516d07fef8febde1364330bb0ee5d56613b1eb590ac5085c601a8ad5b6",
            "metadata": {},
            "name": "useAttachmentsMacroDataQuery",
            "operationKind": "query",
            "text": "query useAttachmentsMacroDataQuery($contentId:ID!,$first:Int=250,$offset:Int=0){singleContent(id:$contentId,status:[\"current\",\"draft\",\"archived\"]){id,operations{operation},attachments(first:$first,offset:$offset){count,pageInfo{hasNextPage},nodes{id,title,type,extensions{key,value},version{number,when,message,by{__typename,...on KnownUser{accountId,displayName,profilePicture{path}},...on UnknownUser{accountId,displayName}}},history{createdDate,createdBy{__typename,...on KnownUser{accountId,displayName,profilePicture{path}},...on UnknownUser{accountId,displayName}}},labels(first:100){nodes{id,name}},operations{operation},links{download}}}}}"
        }
    };
}();
$d4df523b7f0aeb37$var$node.hash = "33018479c42f37e23537bb1c1f20db9c";
var $d4df523b7f0aeb37$export$2e2bcd8739ae039 = $d4df523b7f0aeb37$var$node;


const $477f1fc538783d1e$export$9fd9fa637bd9f2b7 = (0, $d4df523b7f0aeb37$export$2e2bcd8739ae039);


/**
 * @generated SignedSource<<f7635b0e6e5735d76e47e855a5f35d2f>>
 * @relayHash 55924df0b6c78853b0eb4cc2cb9e11ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 36eed5b7f382fc4a11845a1a14c68f62f8795484b622eb70cf44b807e57ee54c
const $d8b771a36c4b0a4f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasSplit"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rawSpaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rawTitle"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "splitSpaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "splitTitle"
    }, v5 = {
        "kind": "Literal",
        "name": "first",
        "value": 1
    }, v6 = [
        {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        }
    ], v7 = [
        {
            "alias": "rawContent",
            "args": [
                v5 /*: any*/ ,
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "rawSpaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "title",
                    "variableName": "rawTitle"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v6 /*: any*/ 
        },
        {
            "condition": "hasSplit",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": "splitContent",
                    "args": [
                        v5 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "splitSpaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "splitTitle"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useAttachmentsPageByTitleQuery",
            "selections": v7 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useAttachmentsPageByTitleQuery",
            "selections": v7 /*: any*/ 
        },
        "params": {
            "cacheID": "55924df0b6c78853b0eb4cc2cb9e11ac",
            "id": "36eed5b7f382fc4a11845a1a14c68f62f8795484b622eb70cf44b807e57ee54c",
            "metadata": {},
            "name": "useAttachmentsPageByTitleQuery",
            "operationKind": "query",
            "text": "query useAttachmentsPageByTitleQuery($rawSpaceKey:String!,$rawTitle:String!,$splitSpaceKey:String!,$splitTitle:String!,$hasSplit:Boolean!){rawContent:content(spaceKey:$rawSpaceKey,title:$rawTitle,first:1){nodes{id,title}},splitContent:content(spaceKey:$splitSpaceKey,title:$splitTitle,first:1)@include(if:$hasSplit){nodes{id,title}}}"
        }
    };
}();
$d8b771a36c4b0a4f$var$node.hash = "0475e2a0f2b864806978d7e16fa5c136";
var $d8b771a36c4b0a4f$export$2e2bcd8739ae039 = $d8b771a36c4b0a4f$var$node;


const $e47c34c2a27f3eeb$export$bb4c31f53a052fe = (0, $d8b771a36c4b0a4f$export$2e2bcd8739ae039);
const $e47c34c2a27f3eeb$export$b5fddb1c0866fa90 = (pageRef, hostSpaceKey)=>{
    const rawTitle = pageRef.trim();
    const colonIdx = pageRef.indexOf(':');
    if (colonIdx > 0) {
        const candidate = pageRef.slice(0, colonIdx).trim();
        const afterColon = pageRef.slice(colonIdx + 1).trim();
        if (candidate && afterColon) return {
            rawTitle: rawTitle,
            rawSpaceKey: hostSpaceKey,
            splitSpaceKey: candidate,
            splitTitle: afterColon,
            hasSplit: true
        };
    }
    return {
        rawTitle: rawTitle,
        rawSpaceKey: hostSpaceKey,
        splitSpaceKey: '',
        splitTitle: '',
        hasSplit: false
    };
};


const $839cdd6a6bc20038$var$DEFAULT_PAGE_SIZE = 500;
const $839cdd6a6bc20038$var$MAX_PAGE_SIZE = 500;
const $839cdd6a6bc20038$export$a4c001b14047c450 = (params)=>{
    const patternsRaw = params.patterns?.value ?? '';
    const labelsRaw = params.labels?.value ?? '';
    const patterns = patternsRaw ? patternsRaw.split(',').reduce((acc, p)=>{
        const trimmed = p.trim();
        if (trimmed) acc.push(trimmed);
        return acc;
    }, []) : [];
    const labels = labelsRaw ? labelsRaw.split(',').reduce((acc, l)=>{
        const trimmed = l.trim();
        if (trimmed) acc.push(trimmed);
        return acc;
    }, []) : [];
    const showVersionHistory = params.old?.value !== 'false';
    const showUpload = params.upload?.value !== 'false';
    const showPreview = params.preview?.value === 'true';
    // The editor panel sends "Sort by" as `sort`; accept both.
    const sortByRaw = params.sortBy?.value ?? params.sort?.value;
    const sortBy = sortByRaw === 'date' || sortByRaw === 'createddate' || sortByRaw === 'size' || sortByRaw === 'name' ? sortByRaw : 'date';
    const sortOrderRaw = params.sortOrder?.value;
    const sortOrder = sortOrderRaw === 'ascending' || sortOrderRaw === 'descending' ? sortOrderRaw : 'ascending';
    // The editor panel sends "Number of items to display" as `num`; accept both.
    const pageSizeRaw = parseInt(params.pageSize?.value ?? params.num?.value ?? '', 10);
    const pageSize = !isNaN(pageSizeRaw) && pageSizeRaw > 0 ? Math.min(pageSizeRaw, $839cdd6a6bc20038$var$MAX_PAGE_SIZE) : $839cdd6a6bc20038$var$DEFAULT_PAGE_SIZE;
    return {
        patterns: patterns,
        labels: labels,
        showVersionHistory: showVersionHistory,
        sortBy: sortBy,
        sortOrder: sortOrder,
        showUpload: showUpload,
        showPreview: showPreview,
        pageRef: params.page?.value ?? undefined,
        pageSize: pageSize
    };
};
const $839cdd6a6bc20038$var$matchesPatterns = (fileName, patterns)=>{
    if (patterns.length === 0) return true;
    return patterns.some((rawPattern)=>{
        try {
            const pattern = rawPattern.startsWith('*') ? '.' + rawPattern : rawPattern;
            return new RegExp(`^(?:${pattern})$`).test(fileName);
        } catch  {
            return false;
        }
    });
};
// AND logic: attachment must have ALL listed labels.
const $839cdd6a6bc20038$var$matchesLabels = (attachmentLabels, requiredLabels)=>{
    if (requiredLabels.length === 0) return true;
    const labelSet = new Set(attachmentLabels);
    return requiredLabels.every((label)=>labelSet.has(label));
};
const $839cdd6a6bc20038$var$sortAttachments = (attachments, sortBy, sortOrder)=>{
    return [
        ...attachments
    ].sort((a, b)=>{
        let comparison = 0;
        switch(sortBy){
            case 'date':
                comparison = new Date(a.lastModificationDate).getTime() - new Date(b.lastModificationDate).getTime();
                break;
            case 'createddate':
                comparison = new Date(a.creationDate).getTime() - new Date(b.creationDate).getTime();
                break;
            case 'size':
                comparison = a.fileSize - b.fileSize;
                break;
            case 'name':
                comparison = a.fileName.toLowerCase().localeCompare(b.fileName.toLowerCase());
                break;
        }
        return sortOrder === 'descending' ? -comparison : comparison;
    });
};
const $839cdd6a6bc20038$export$f1b2cc328921b868 = (params, contentId, hostSpaceKey)=>{
    const resolved = (0, $cozmU.useMemo)(()=>$839cdd6a6bc20038$export$a4c001b14047c450(params), [
        params
    ]);
    // Cross-page mode: resolve the target page's id by title.
    // Uses a dual-query fallback: both "split on colon" and "raw bare title" interpretations
    // are fetched in one request. Split is preferred; raw is the fallback (handles colons in titles).
    const crossPageTarget = (0, $cozmU.useMemo)(()=>resolved.pageRef ? (0, $e47c34c2a27f3eeb$export$b5fddb1c0866fa90)(resolved.pageRef, hostSpaceKey) : null, [
        resolved.pageRef,
        hostSpaceKey
    ]);
    const isCrossPage = !!crossPageTarget?.rawTitle && !!crossPageTarget?.rawSpaceKey;
    const titleQuery = (0, $jMyy4.useQueryInterop)((0, $e47c34c2a27f3eeb$export$bb4c31f53a052fe), {
        variables: {
            rawSpaceKey: crossPageTarget?.rawSpaceKey ?? '',
            rawTitle: crossPageTarget?.rawTitle ?? '',
            splitSpaceKey: crossPageTarget?.splitSpaceKey ?? '',
            splitTitle: crossPageTarget?.splitTitle ?? '',
            hasSplit: crossPageTarget?.hasSplit ?? false
        },
        fetchPolicy: 'cache-first',
        skip: !isCrossPage,
        __callerPackage__: "attachments-macro"
    });
    // Resolution: prefer split (cross-space) result; fall back to raw (bare title in host space).
    // Case-insensitive title match (legacy is case-insensitive).
    const splitNode = titleQuery.data?.splitContent?.nodes?.[0];
    const rawNode = titleQuery.data?.rawContent?.nodes?.[0];
    const crossPageResolvedId = (0, $cozmU.useMemo)(()=>{
        // Try split interpretation first (e.g. "DEV:My Page" → space DEV, title "My Page")
        if (splitNode?.title && crossPageTarget?.splitTitle && splitNode.title.toLowerCase() === crossPageTarget.splitTitle.toLowerCase()) return splitNode.id ?? null;
        if (rawNode?.title && crossPageTarget?.rawTitle && rawNode.title.toLowerCase() === crossPageTarget.rawTitle.toLowerCase()) return rawNode.id ?? null;
        return null;
    }, [
        splitNode,
        rawNode,
        crossPageTarget
    ]);
    const crossPageNotFound = isCrossPage && !titleQuery.loading && !crossPageResolvedId;
    const effectiveContentId = isCrossPage ? crossPageResolvedId : contentId ?? null;
    const [sortBy, setSortBy] = (0, $cozmU.useState)(resolved.sortBy);
    const [sortOrder, setSortOrder] = (0, $cozmU.useState)(resolved.sortOrder);
    const [currentPage, setCurrentPage] = (0, $cozmU.useState)(1);
    // Sync sort state when macro params change (e.g. editor panel dropdown).
    (0, $cozmU.useEffect)(()=>{
        setSortBy(resolved.sortBy);
        setSortOrder(resolved.sortOrder);
        setCurrentPage(1);
    }, [
        resolved.sortBy,
        resolved.sortOrder
    ]);
    // Always fetch all attachments and paginate client-side, matching legacy behavior.
    // This gives us the true total upfront so all page numbers render immediately.
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $477f1fc538783d1e$export$9fd9fa637bd9f2b7), {
        variables: {
            contentId: effectiveContentId ?? '',
            first: $839cdd6a6bc20038$var$DEFAULT_PAGE_SIZE,
            offset: 0
        },
        fetchPolicy: 'cache-first',
        skip: !effectiveContentId,
        __callerPackage__: "attachments-macro"
    });
    // DSP check — defaults to false so downloads aren't transiently hidden.
    const { isDisabled: dspBlocksDownloads = false } = (0, $fUCKK.useIsAttachmentDownloadDisabled)({
        contentId: effectiveContentId ?? '',
        skip: !effectiveContentId
    });
    const rawPageId = data?.singleContent?.id ?? '';
    // AGG returns ARI format (ari:cloud:confluence::content/12345); download URLs need bare numeric ID.
    const pageId = (0, $938f1daee99da6d8$export$839894812e415e90)(rawPageId);
    const hasAttachFilePermission = data?.singleContent?.operations?.some((o)=>o?.operation?.toLowerCase() === 'create_attachment') ?? false;
    // Normalize raw GraphQL nodes; bad/redacted nodes are dropped.
    const allAttachments = (0, $cozmU.useMemo)(()=>{
        const nodes = data?.singleContent?.attachments?.nodes ?? [];
        return nodes.flatMap((node)=>{
            const normalized = (0, $cfd67d8c6a811bce$export$6f29ddb57f342c25)(node);
            return normalized ? [
                normalized
            ] : [];
        });
    }, [
        data
    ]);
    // Filter
    const filtered = (0, $cozmU.useMemo)(()=>allAttachments.filter((att)=>$839cdd6a6bc20038$var$matchesPatterns(att.fileName, resolved.patterns) && $839cdd6a6bc20038$var$matchesLabels(att.labels, resolved.labels)), [
        allAttachments,
        resolved.patterns,
        resolved.labels
    ]);
    // Sort client-side.
    const sorted = (0, $cozmU.useMemo)(()=>$839cdd6a6bc20038$var$sortAttachments(filtered, sortBy, sortOrder), [
        filtered,
        sortBy,
        sortOrder
    ]);
    // Client-side pagination: derive totalPages from the full filtered list,
    // then slice to the current page. This matches legacy behavior and gives
    // us the true total upfront so all page numbers render immediately.
    const totalCount = sorted.length;
    const totalPages = Math.max(1, Math.ceil(totalCount / resolved.pageSize));
    const hasNextPage = currentPage < totalPages;
    // Reset to page 1 when pageSize or content changes.
    const prevContentId = (0, $cozmU.useRef)(effectiveContentId);
    const prevPageSize = (0, $cozmU.useRef)(resolved.pageSize);
    (0, $cozmU.useEffect)(()=>{
        if (prevContentId.current !== effectiveContentId || prevPageSize.current !== resolved.pageSize) {
            prevContentId.current = effectiveContentId;
            prevPageSize.current = resolved.pageSize;
            setCurrentPage(1);
        }
    }, [
        effectiveContentId,
        resolved.pageSize
    ]);
    const safePage = Math.min(currentPage, totalPages);
    const pageStart = (safePage - 1) * resolved.pageSize;
    const attachments = sorted.slice(pageStart, pageStart + resolved.pageSize);
    const onSort = (0, $cozmU.useCallback)((column)=>{
        if (column === sortBy) setSortOrder((prev)=>prev === 'ascending' ? 'descending' : 'ascending');
        else {
            setSortBy(column);
            setSortOrder('ascending');
        }
        setCurrentPage(1);
    }, [
        sortBy
    ]);
    // Combine cross-page and main query loading/error states.
    const combinedLoading = loading || isCrossPage && titleQuery.loading;
    const combinedError = error ?? titleQuery.error ?? (crossPageNotFound ? new Error('attachments-macro: cross-page target not found') : null);
    return {
        attachments: attachments,
        totalCount: totalCount,
        currentPage: safePage,
        totalPages: totalPages,
        hasNextPage: hasNextPage,
        pageId: pageId,
        dspBlocksDownloads: dspBlocksDownloads,
        hasAttachFilePermission: hasAttachFilePermission,
        loading: combinedLoading,
        error: combinedError,
        sortBy: sortBy,
        sortOrder: sortOrder,
        onSort: onSort,
        onPageChange: setCurrentPage,
        showVersionHistory: resolved.showVersionHistory,
        showUpload: resolved.showUpload,
        showPreview: resolved.showPreview,
        refetch: refetch
    };
};


/* AttachmentsTable.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $hekY6 = parcelRequire("hekY6");











var $1sCHt = parcelRequire("1sCHt");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $gC2EJ = parcelRequire("gC2EJ");


var $7vK9E = parcelRequire("7vK9E");








var $hBYtq = parcelRequire("hBYtq");








var $IOtUu = parcelRequire("IOtUu");


var $8aF6s = parcelRequire("8aF6s");


var $8WOej = parcelRequire("8WOej");


var $4vaoM = parcelRequire("4vaoM");


var $a6t12 = parcelRequire("a6t12");


var $jJK3p = parcelRequire("jJK3p");


var $jmjWc = parcelRequire("jmjWc");


const $498b4d3c7188a5fd$export$ac5b2e3000a234e6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "dv62p",
    name: "AttachmentsMacroDeleteDialogLoader",
    loader: async ()=>(await (parcelRequire("2NFTR"))).DeleteAttachmentDialog
});






const $75b321f55cb7410a$export$e7280d4558903aa6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "qhrp1",
    name: "AttachmentsMacroEditPropertiesDialogLoader",
    loader: async ()=>(await (parcelRequire("90na9"))).EditAttachmentPropertiesDialog
});





/**
 * @generated SignedSource<<c73b84528b32969738991b784b8fc5a4>>
 * @relayHash 788b2558ba947f1feca9c76145ac9019
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 725fbd46a2bbd5c4e2910fd04de40d9b84fdd5fb72a23bf6fcbffc5862450003
const $065f117e617fa3b2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "attachmentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "filter",
                    "variableName": "filter"
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 100
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "attachmentId"
                }
            ],
            "concreteType": "ContentVersionHistoryConnection",
            "kind": "LinkedField",
            "name": "contentVersionHistory",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentVersion",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "updatedTime"
                        },
                        {
                            "concreteType": "AtlassianUser",
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAttachmentVersionsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAttachmentVersionsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "788b2558ba947f1feca9c76145ac9019",
            "id": "725fbd46a2bbd5c4e2910fd04de40d9b84fdd5fb72a23bf6fcbffc5862450003",
            "metadata": {},
            "name": "useAttachmentVersionsQuery",
            "operationKind": "query",
            "text": "query useAttachmentVersionsQuery($attachmentId:ID!,$filter:ContentVersionHistoryFilter!){contentVersionHistory(id:$attachmentId,first:100,filter:$filter){nodes{number,updatedTime,author{id,displayName},message}}}"
        }
    };
}();
$065f117e617fa3b2$var$node.hash = "341106a5916dead04c88b1727c2fd806";
var $065f117e617fa3b2$export$2e2bcd8739ae039 = $065f117e617fa3b2$var$node;








const $175fcc2808c76aae$export$ba6e31ac6400cf6e = (0, $065f117e617fa3b2$export$2e2bcd8739ae039);
const $175fcc2808c76aae$export$72235b7881904a71 = (attachmentId, skip = false)=>{
    const shouldSkip = skip || !attachmentId;
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($175fcc2808c76aae$export$ba6e31ac6400cf6e, {
        variables: {
            attachmentId: attachmentId ?? '',
            filter: {
                contentType: 'attachment'
            }
        },
        fetchPolicy: 'cache-and-network',
        skip: shouldSkip,
        __callerPackage__: "attachments-macro"
    });
    const versions = (0, $cozmU.useMemo)(()=>{
        const rawNodes = data?.contentVersionHistory?.nodes ?? [];
        // Drop null nodes (DSP eviction / auth) and sort newest-first.
        const filtered = rawNodes.filter((n)=>Boolean(n));
        filtered.sort((a, b)=>(b.number ?? 0) - (a.number ?? 0));
        return filtered.map((node, index)=>{
            const modifier = {
                displayName: node.author?.displayName ?? '',
                accountId: node.author?.id ?? '',
                // profilePicture is required by AttachmentUser but the
                // `contentVersionHistory` doesn't expose it; default to empty path.
                profilePicture: {
                    path: ''
                }
            };
            return {
                version: node.number ?? 0,
                isLatestVersion: index === 0,
                isNew: (node.number ?? 0) === 1,
                comment: node.message ?? '',
                contentType: 'attachment',
                creationDate: node.updatedTime ?? '',
                modifier: modifier
            };
        });
    }, [
        data
    ]);
    return {
        versions: versions,
        loading: Boolean(loading && !data),
        error: error ?? null,
        refetch: refetch
    };
};


// The confluence-previews WRM plugin is already loaded at the View Page shell
// level, so the jQuery delegation listener is active for anchors with the
// legacy `previewAttachmentLink` className and `data-linked-resource-*`
// attributes. We do not need to require the plugin ourselves.
//
// The only shared piece needed by the table is the ARI → bare-id transform
// the legacy previewer expects in its href.
// Strip ARI wrapper → bare numeric id the legacy previewer expects.
const $e36cf3ddad0b1ff1$export$eb84bb3611c34203 = (attachmentId)=>{
    if (!attachmentId) return attachmentId;
    const tail = attachmentId.includes('/') ? attachmentId.slice(attachmentId.lastIndexOf('/') + 1) : attachmentId;
    return /^att\d+$/.test(tail) ? tail.slice(3) : tail;
};
const $e36cf3ddad0b1ff1$export$b94bb2313d0cac15 = ({ pageId: pageId, attachmentId: attachmentId, fileName: fileName })=>`/${pageId}/${$e36cf3ddad0b1ff1$export$eb84bb3611c34203(attachmentId)}/${fileName}`;



var $eATLT = parcelRequire("eATLT");








const $3f8404c735b4d0c7$var$DAY_MS = 86400000;
const $3f8404c735b4d0c7$export$359f3c271cd167e3 = (dateString, intl)=>{
    return intl.formatDate(new Date(dateString), {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
};
const $3f8404c735b4d0c7$export$d1f5a2f86fcde3b5 = (dateString, intl)=>{
    const timestamp = new Date(dateString).getTime();
    const diffMs = Date.now() - timestamp;
    if (diffMs < $3f8404c735b4d0c7$var$DAY_MS) {
        const diffSeconds = Math.floor(diffMs / 1000);
        if (diffSeconds < 60) return intl.formatRelativeTime(-diffSeconds, 'second', {
            numeric: 'auto'
        });
        const diffMinutes = Math.floor(diffSeconds / 60);
        if (diffMinutes < 60) return intl.formatRelativeTime(-diffMinutes, 'minute', {
            numeric: 'auto'
        });
        const diffHours = Math.floor(diffMinutes / 60);
        return intl.formatRelativeTime(-diffHours, 'hour', {
            numeric: 'auto'
        });
    }
    return intl.formatDate(new Date(dateString), {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
};


const $00897712c2a818f9$export$b42cbe5200b6a529 = ({ dateString: dateString })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [mounted, setMounted] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setMounted(true);
    }, []);
    const formatted = mounted ? (0, $3f8404c735b4d0c7$export$d1f5a2f86fcde3b5)(dateString, intl) : (0, $3f8404c735b4d0c7$export$359f3c271cd167e3)(dateString, intl);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, formatted);
};


/* VersionHistory.tsx generated by @compiled/babel-plugin v0.40.0 */ 































const $518c69f5d3dcd4ab$var$styles = {
    headingWrapper: "_85i5ze3t",
    versionTable: "_1bsb1osq _yq5hcfaq _uwhke4h9 _15a5nqa1 _1i531l7x",
    versionLink: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz13af",
    versionRow: "_1doce4h9 _1il9nqa1 _1o3i1l7x",
    versionNumCell: "_1q51u2gc _85i5u2gc _y4tipxbi _o5721q9c _s7n4jp4b _1ul99xn7",
    versionCell: "_1q51u2gc _85i5u2gc _y4tipxbi _s7n4jp4b",
    versionDateCell: "_1q51u2gc _85i5u2gc _y4tize3t _s7n4jp4b"
};
const $518c69f5d3dcd4ab$export$bc676b00e8f62584 = ({ attachmentId: attachmentId, versions: versions, contentId: contentId, fileName: fileName, dspBlocksDownloads: dspBlocksDownloads })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $518c69f5d3dcd4ab$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle",
        weight: "bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).versionHistory))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "table",
        xcss: $518c69f5d3dcd4ab$var$styles.versionTable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "tbody"
    }, versions.map((version)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "tr",
            key: version.version,
            xcss: $518c69f5d3dcd4ab$var$styles.versionRow,
            testId: `attachment-version-row-${attachmentId}-${version.version}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "td",
            xcss: $518c69f5d3dcd4ab$var$styles.versionNumCell
        }, dspBlocksDownloads ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).version), " ", version.version), version.isLatestVersion && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).currentVersion))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            href: contentId ? (0, $938f1daee99da6d8$export$294caf8e77e086a1)(contentId, fileName, version.version) : '',
            xcss: $518c69f5d3dcd4ab$var$styles.versionLink
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).version), " ", version.version), version.isLatestVersion && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).currentVersion)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "td",
            xcss: $518c69f5d3dcd4ab$var$styles.versionCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...version.isNew ? (0, $dJsIz.i18n).createdByUser : (0, $dJsIz.i18n).modifiedByUser,
            values: {
                userName: version.modifier.accountId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
                    userId: version.modifier.accountId,
                    fullName: version.modifier.displayName,
                    position: "bottom-start"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJK3p.ProfileLink), {
                    userId: version.modifier.accountId,
                    fullName: version.modifier.displayName,
                    behavior: "link",
                    referralSource: "attachments-macro-version",
                    isUnderlinedByDefault: false
                })) : version.modifier.displayName
            }
        }))), version.comment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "td",
            xcss: $518c69f5d3dcd4ab$var$styles.versionCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, version.comment)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "td",
            xcss: $518c69f5d3dcd4ab$var$styles.versionDateCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $00897712c2a818f9$export$b42cbe5200b6a529), {
            dateString: version.creationDate
        }))))))));
};


const $611d5e7367d032a6$var$styles = {
    previewActionLink: "_2rko12b0 _11c8fhey _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjcv77o _18zrutpp _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c116y _4cvr1h6o _vchhusvi _bfhksm61 _syazazsu _k48p1wq8 _80omtlke _1053azsu _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31dpa _30l3azsu _1di6fcek",
    table: "_1bsb1osq _yq5hcfaq _1kqm1wug",
    headerRow: "_7myae4h9 _1sw7nqa1 _qgnu1l7x _1r62e4h9 _12ornqa1 _1ezz1l7x",
    firstHeaderCell: "_1rjcu2gc _y3gnv2br _1bsb1n05 _bozgze3t _y4tiu2gc _s7n4nkob",
    bodyCell: "_1rjcutpp _18zru2gc _1bsb1n05 _1r62e4h9 _12ornqa1 _1ezz1l7x _s7n4nkob",
    modifiedHeaderCell: "_1rjcu2gc _y3gnv2br _bozg1ejb _y4tiu2gc _s7n4nkob",
    modifiedBodyCell: "_1rjcutpp _1r62e4h9 _12ornqa1 _1ezz1l7x _bozg1ejb _y4tiu2gc _s7n4nkob",
    expandedCell: "_1rjcze3t _18zrze3t _1r62e4h9 _12ornqa1 _1ezz1l7x",
    fileLink: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz13af _9oik1r31 _1bnx8stv _jf4cnqa1",
    expandedDetailsWrapper: "_1q51utpp _85i5pxbi _bozg1jfw _y4ti1ejb",
    labelsContentIndent: "_bozg1b66",
    previewContainer: "_1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x _bfhkhfxm _1bsb1ns9 _p12f1osq _80omtlke",
    previewImage: "_1e0c1ule _p12f1osq _c71lnklw _1bsb1wug _4t3i1wug _5ral1f51",
    previewFallback: "_1q51utpp _85i5utpp _bozgpxbi _y4tipxbi _1ul9nklw",
    expandButton: "_1yt41b66 _80omtlke _1e0c1txw _4cvr1h6o _bfhksm61",
    expandButtonSpacer: "_1bsb1tcg _1o9zidpf"
};
// Download URL helpers are in ../downloadUrl.ts (shared with VersionHistory).
// Lazily fetches version history when a row is expanded.
// Shows every version (even single-version files) to match legacy behaviour.
const $611d5e7367d032a6$var$ExpandedVersionHistory = ({ attachment: attachment, contentId: contentId, dspBlocksDownloads: dspBlocksDownloads })=>{
    const { versions: versions } = (0, $175fcc2808c76aae$export$72235b7881904a71)(attachment.id);
    if (versions.length < 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $518c69f5d3dcd4ab$export$bc676b00e8f62584), {
        attachmentId: attachment.id,
        versions: versions,
        contentId: contentId,
        fileName: attachment.fileName,
        dspBlocksDownloads: dspBlocksDownloads
    });
};
const $611d5e7367d032a6$var$buildThumbnailUrl = (pageId, fileName, version)=>{
    if (typeof window === 'undefined' || !pageId) return '';
    const versionParam = version ? `?version=${version}` : '';
    return `${window.location.origin}/wiki/download/thumbnails/${pageId}/${encodeURIComponent(fileName)}${versionParam}`;
}; // Inline thumbnail preview. Falls back to a clickable card when the
// thumbnail 404s. Rendered as an anchor with legacy data attributes so
// the jQuery delegation opens the overlay on click.
const $611d5e7367d032a6$var$InlineAttachmentPreview = ({ attachment: attachment, contentId: contentId, previewHref: previewHref, bareAttachmentId: bareAttachmentId, canPreview: canPreview })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [thumbnailFailed, setThumbnailFailed] = (0, $cozmU.useState)(false);
    if (!attachment.hasViewPermission) return null;
    const thumbnailUrl = $611d5e7367d032a6$var$buildThumbnailUrl(contentId, attachment.fileName, attachment.version);
    if (!thumbnailUrl) return null;
    const altText = intl.formatMessage((0, $dJsIz.i18n).inlinePreviewAlt, {
        fileName: attachment.fileName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
        "data-testid": `attachments-preview-${attachment.id}`,
        href: canPreview ? previewHref : undefined,
        className: (0, $hekY6.default)([
            $611d5e7367d032a6$var$styles.previewContainer,
            "previewAttachmentLink"
        ]),
        "data-linked-resource-type": "attachment",
        "data-linked-resource-id": bareAttachmentId,
        "data-linked-resource-container-id": contentId,
        "data-linked-resource-default-alias": attachment.fileName,
        "data-linked-resource-content-type": attachment.mediaType ?? ''
    }, thumbnailFailed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $611d5e7367d032a6$var$styles.previewFallback,
        testId: `attachments-preview-fallback-${attachment.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, attachment.fileName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).preview)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "img",
        xcss: $611d5e7367d032a6$var$styles.previewImage,
        src: thumbnailUrl,
        alt: altText,
        loading: "lazy",
        onError: ()=>setThumbnailFailed(true)
    }));
};
const $611d5e7367d032a6$var$ExpandedRowDetails = ({ attachment: attachment, contentId: contentId, spaceKey: spaceKey, dspBlocksDownloads: dspBlocksDownloads, showPreview: showPreview, showVersionHistory: showVersionHistory, onAttachmentUpdated: onAttachmentUpdated })=>{
    const intl = (0, $kSwu1.useIntl)();
    const editLabelsLabel = intl.formatMessage((0, $dJsIz.i18n).editLabels);
    const { showModal: showModal } = (0, $8aF6s.useDialogs)(); // The confluence-previews WRM plugin is bootstrapped by the View Page shell,
    // so the delegation listener is always active — no local loader needed.
    // Guard: without a contentId the previewHref is '#' and the confluence-previews
    // delegation has no valid resource id to open, so skip the anchors entirely.
    const canPreview = Boolean(attachment.id && contentId);
    const bareAttachmentId = (0, $e36cf3ddad0b1ff1$export$eb84bb3611c34203)(attachment.id);
    const previewHref = contentId ? `/wiki/download/attachments/${contentId}/${encodeURIComponent(attachment.fileName)}` : '#';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $611d5e7367d032a6$var$styles.expandedDetailsWrapper,
        testId: `attachments-detail-${attachment.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, showPreview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($611d5e7367d032a6$var$InlineAttachmentPreview, {
        attachment: attachment,
        contentId: contentId,
        previewHref: previewHref,
        bareAttachmentId: bareAttachmentId,
        canPreview: canPreview
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).labels)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $611d5e7367d032a6$var$styles.labelsContentIndent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, attachment.labels.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050"
    }, attachment.labels.map((label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
            key: label,
            text: label,
            href: (0, $eATLT.buildLabelUrl)(label, spaceKey),
            isRemovable: false,
            color: "grey"
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).noLabels)), contentId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
        label: editLabelsLabel,
        onClick: ()=>{
            showModal((0, $4vaoM.EditLabelDialogLoader), {
                contentId: attachment.id,
                spaceKey: spaceKey ?? '',
                source: 'attachmentsMacro',
                onCloseComplete: onAttachmentUpdated
            });
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
        label: editLabelsLabel,
        isDisabled: true
    })))), showVersionHistory && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($611d5e7367d032a6$var$ExpandedVersionHistory, {
        key: `${attachment.id}-${attachment.version}-${attachment.versionComment}`,
        attachment: attachment,
        contentId: contentId,
        dspBlocksDownloads: dspBlocksDownloads
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, canPreview && attachment.hasPreviewPermission && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
        href: previewHref,
        className: (0, $hekY6.default)([
            $611d5e7367d032a6$var$styles.previewActionLink,
            "previewAttachmentLink"
        ]),
        "data-linked-resource-type": "attachment",
        "data-linked-resource-id": bareAttachmentId,
        "data-linked-resource-container-id": contentId,
        "data-linked-resource-default-alias": attachment.fileName,
        "data-linked-resource-content-type": attachment.mediaType ?? ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).preview)), canPreview && attachment.hasViewPermission && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
        href: previewHref,
        className: (0, $hekY6.default)([
            $611d5e7367d032a6$var$styles.previewActionLink,
            "previewAttachmentLink"
        ]),
        "data-linked-resource-type": "attachment",
        "data-linked-resource-id": bareAttachmentId,
        "data-linked-resource-container-id": contentId,
        "data-linked-resource-default-alias": attachment.fileName,
        "data-linked-resource-content-type": attachment.mediaType ?? ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).view)), (attachment.hasEditPermission || attachment.hasDeletePermission) && contentId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, attachment.hasEditPermission && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        spacing: "compact",
        onClick: ()=>{
            showModal((0, $75b321f55cb7410a$export$e7280d4558903aa6), {
                contentId: contentId,
                attachment: {
                    title: attachment.fileName,
                    extensions: [
                        {
                            key: 'mediaType',
                            value: attachment.mediaType ?? ''
                        },
                        {
                            key: 'comment',
                            value: attachment.versionComment ?? ''
                        }
                    ]
                },
                attachmentId: attachment.id,
                labels: attachment.labels,
                spaceKey: spaceKey ?? '',
                handleAttachmentUpdated: onAttachmentUpdated ?? (()=>{})
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).properties)), attachment.hasDeletePermission && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        spacing: "compact",
        onClick: ()=>{
            showModal((0, $498b4d3c7188a5fd$export$ac5b2e3000a234e6), {
                attachmentId: attachment.id,
                attachmentName: attachment.fileName,
                onDeleted: onAttachmentUpdated
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).deleteAttachment))))));
};
const $611d5e7367d032a6$export$4669696b373a5d47 = ({ attachments: attachments, dspBlocksDownloads: dspBlocksDownloads, showVersionHistory: showVersionHistory, showPreview: showPreview, contentId: contentId, spaceKey: spaceKey, onAttachmentUpdated: onAttachmentUpdated })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [expandedIds, setExpandedIds] = (0, $cozmU.useState)(new Set()); // Keep the clicked row pinned when expanding/collapsing (content grows downward).
    const expandAnchorRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const anchor = expandAnchorRef.current;
        if (!anchor) return;
        expandAnchorRef.current = null;
        const delta = anchor.el.getBoundingClientRect().top - anchor.top;
        if (delta === 0) return;
        let node = anchor.el.parentElement;
        while(node){
            const { overflowY: overflowY } = window.getComputedStyle(node);
            if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) {
                node.scrollTop += delta;
                return;
            }
            node = node.parentElement;
        }
        window.scrollBy(0, delta);
    }, [
        expandedIds
    ]);
    const toggleExpand = (id, trigger)=>{
        expandAnchorRef.current = {
            el: trigger,
            top: trigger.getBoundingClientRect().top
        };
        setExpandedIds((prev)=>{
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: "plugin_attachments_container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "table",
        xcss: $611d5e7367d032a6$var$styles.table,
        testId: "attachments-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "thead"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "tr",
        xcss: $611d5e7367d032a6$var$styles.headerRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "th",
        xcss: $611d5e7367d032a6$var$styles.firstHeaderCell,
        scope: 'col'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        size: "large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).columnName))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "th",
        xcss: $611d5e7367d032a6$var$styles.modifiedHeaderCell,
        scope: 'col'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        size: "large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).columnModified))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "tbody"
    }, attachments.flatMap((attachment)=>{
        const isExpanded = expandedIds.has(attachment.id);
        const mainRow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "tr",
            key: attachment.id,
            testId: `attachments-row-${attachment.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "td",
            xcss: $611d5e7367d032a6$var$styles.bodyCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            type: "button",
            "aria-expanded": isExpanded,
            "aria-label": intl.formatMessage(isExpanded ? (0, $dJsIz.i18n).collapseVersionHistory : (0, $dJsIz.i18n).expandVersionHistory, {
                fileName: attachment.fileName
            }),
            onClick: (event)=>toggleExpand(attachment.id, event.currentTarget),
            xcss: $611d5e7367d032a6$var$styles.expandButton,
            testId: `attachments-expand-${attachment.id}`
        }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: "",
            size: "small"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8WOej.AttachmentIcon), {
            mediaType: attachment.mediaType,
            title: attachment.fileName,
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, dspBlocksDownloads ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, attachment.fileName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            href: (0, $938f1daee99da6d8$export$ab3bbcca4ee23e63)(contentId, attachment.fileName, attachment.version, attachment.downloadPath),
            xcss: $611d5e7367d032a6$var$styles.fileLink,
            testId: `attachments-link-${attachment.id}`
        }, attachment.fileName), attachment.versionComment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, attachment.versionComment) : null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "td",
            xcss: $611d5e7367d032a6$var$styles.modifiedBodyCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $dJsIz.i18n).dateByUser,
            values: {
                date: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $00897712c2a818f9$export$b42cbe5200b6a529), {
                    dateString: attachment.lastModificationDate
                }),
                userName: attachment.lastModifier.accountId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
                    userId: attachment.lastModifier.accountId,
                    fullName: attachment.lastModifier.displayName,
                    position: "bottom-start"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJK3p.ProfileLink), {
                    userId: attachment.lastModifier.accountId,
                    fullName: attachment.lastModifier.displayName,
                    behavior: "link",
                    referralSource: "attachments-macro",
                    isUnderlinedByDefault: false
                })) : attachment.lastModifier.displayName
            }
        }))));
        if (!isExpanded) return [
            mainRow
        ];
        const expandedRow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "tr",
            key: `${attachment.id}-expanded`,
            testId: `attachments-row-${attachment.id}-expanded`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "td",
            xcss: $611d5e7367d032a6$var$styles.expandedCell,
            colSpan: 2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($611d5e7367d032a6$var$ExpandedRowDetails, {
            attachment: attachment,
            contentId: contentId,
            spaceKey: spaceKey,
            dspBlocksDownloads: dspBlocksDownloads,
            showPreview: showPreview,
            showVersionHistory: showVersionHistory,
            onAttachmentUpdated: onAttachmentUpdated
        })));
        return [
            mainRow,
            expandedRow
        ];
    })))));
};


/* DownloadAllLink.tsx generated by @compiled/babel-plugin v0.40.0 */ 






var $6Fmj3 = parcelRequire("6Fmj3");













const $f5b9146798ce3e3e$var$DOWNLOAD_ALL_PATH = '/wiki/download/all_attachments';
const $f5b9146798ce3e3e$var$styles = {
    wrapper: "_1q51utpp",
    link: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1e0c116y _4cvr1h6o _syaz13af"
};
const $f5b9146798ce3e3e$export$5be0a2f9f1b8b1dd = ({ pageId: pageId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const href = `${$f5b9146798ce3e3e$var$DOWNLOAD_ALL_PATH}?pageId=${pageId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5b9146798ce3e3e$var$styles.wrapper,
        testId: "attachments-download-all"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: href,
        title: formatMessage((0, $dJsIz.i18n).downloadAllDesc),
        xcss: $f5b9146798ce3e3e$var$styles.link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Fmj3))), {
        label: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).downloadAll))));
};

















const $f5bf95bf72494088$export$fddf379e22a74b00 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "attachments-empty-state",
        padding: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).noAttachments)));






const $584b28363e3351a4$export$d436ae89c1f2e9e9 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "iFOsl",
    name: "AttachmentsMacroUploadLoader",
    loader: async ()=>(await (parcelRequire("aJ4wx"))).AttachmentsMacroUpload
});


const $f90b58b6141ee4f5$var$EMPTY_PARAMS = {};
const $f90b58b6141ee4f5$var$AttachmentsMacroRendererComponent = ({ macroDefaultProps: macroDefaultProps, macroParams: macroParams })=>{
    const { contentId: contentId, extensionKey: extensionKey, mode: mode, node: node } = macroDefaultProps;
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const attributes = macroDefaultProps.attributes ?? (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const experienceName = (0, $5kjCz.getExperienceName)(mode, node);
    const { attachments: attachments, totalCount: totalCount, currentPage: currentPage, totalPages: totalPages, hasNextPage: hasNextPage, pageId: pageId, dspBlocksDownloads: dspBlocksDownloads, error: // hasAttachFilePermission not used — upload permission is enforced server-side.
    error, onPageChange: onPageChange, showVersionHistory: showVersionHistory, showUpload: showUpload, showPreview: showPreview, refetch: refetch } = (0, $839cdd6a6bc20038$export$f1b2cc328921b868)(macroParams ?? $f90b58b6141ee4f5$var$EMPTY_PARAMS, contentId, spaceKey ?? undefined);
    const handleAttachmentUpdated = (0, $cozmU.useCallback)(()=>{
        refetch?.();
    }, [
        refetch
    ]);
    const handlePageClick = (0, $cozmU.useCallback)((p)=>()=>onPageChange(p), [
        onPageChange
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        padding: "space.300",
        testId: "attachments-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).errorGeneric)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes,
        error: error
    }));
    const isEmpty = attachments.length === 0;
    const showEmptyState = isEmpty;
    const showDownloadAll = totalCount > 1 && !dspBlocksDownloads;
    // Show the upload area when the macro param enables it. Permission is
    // enforced server-side on the upload POST (403 → error state).
    const showUploadArea = showUpload && Boolean(contentId);
    const pages = Array.from({
        length: totalPages
    }, (_, i)=>i + 1);
    const showPagination = totalPages > 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "attachments-macro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.025"
    }, showEmptyState ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f5bf95bf72494088$export$fddf379e22a74b00), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $611d5e7367d032a6$export$4669696b373a5d47), {
        attachments: attachments,
        dspBlocksDownloads: dspBlocksDownloads,
        showVersionHistory: showVersionHistory,
        showPreview: showPreview,
        contentId: pageId || contentId || undefined,
        spaceKey: spaceKey ?? undefined,
        onAttachmentUpdated: handleAttachmentUpdated
    }), showPagination && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center",
        testId: "attachments-pagination"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "compact",
        isDisabled: currentPage <= 1,
        onClick: ()=>onPageChange(currentPage - 1),
        testId: "attachments-pagination-prev"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).paginationPrev)), pages.map((p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            key: p,
            appearance: "subtle",
            spacing: "compact",
            isSelected: p === currentPage,
            onClick: handlePageClick(p),
            testId: `attachments-pagination-page-${p}`
        }, p)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "compact",
        isDisabled: currentPage >= totalPages && !hasNextPage,
        onClick: ()=>onPageChange(currentPage + 1),
        testId: "attachments-pagination-next"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).paginationNext)))), showUploadArea && contentId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $584b28363e3351a4$export$d436ae89c1f2e9e9), {
        contentId: contentId,
        onFilesUploaded: handleAttachmentUpdated
    }), showDownloadAll && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f5b9146798ce3e3e$export$5be0a2f9f1b8b1dd), {
        pageId: pageId
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }));
};
const $f90b58b6141ee4f5$var$renderErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).errorGeneric);
const $f90b58b6141ee4f5$export$983565c6d2beb10 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        renderOnError: $f90b58b6141ee4f5$var$renderErrorFallback,
        attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f90b58b6141ee4f5$var$AttachmentsMacroRendererComponent, props));
module.exports["AttachmentsMacroRenderer"] = $f90b58b6141ee4f5$export$983565c6d2beb10;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});

parcelRegister("dJsIz", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $ada0102ecadc3b3d$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    noAttachments: {
        id: "attachments-macro.no-attachments",
        defaultMessage: "There are currently no attachments on this page."
    },
    download: {
        id: "attachments-macro.download",
        defaultMessage: "Download"
    },
    version: {
        id: "attachments-macro.version",
        defaultMessage: "Version"
    },
    currentVersion: {
        id: "attachments-macro.current-version",
        defaultMessage: "(current version)"
    },
    dateByUser: {
        id: "attachments-macro.date-by-user",
        defaultMessage: "{date} by {userName}"
    },
    modifiedByUser: {
        id: "attachments-macro.modified-by-user",
        defaultMessage: "Modified by {userName}"
    },
    createdByUser: {
        id: "attachments-macro.created-by-user",
        defaultMessage: "Created by {userName}"
    },
    versionHistory: {
        id: "attachments-macro.version-history",
        defaultMessage: "Version history"
    },
    labels: {
        id: "attachments-macro.labels",
        defaultMessage: "Labels"
    },
    noLabels: {
        id: "attachments-macro.no-labels",
        defaultMessage: "No labels"
    },
    editLabels: {
        id: "attachments-macro.edit-labels",
        defaultMessage: "Edit labels"
    },
    paginationPrev: {
        id: "attachments-macro.pagination.prev",
        defaultMessage: "Prev"
    },
    paginationNext: {
        id: "attachments-macro.pagination.next",
        defaultMessage: "Next"
    },
    preview: {
        id: "attachments-macro.preview",
        defaultMessage: "Preview"
    },
    inlinePreviewAlt: {
        id: "attachments-macro.inline-preview-alt",
        defaultMessage: "Preview of {fileName}"
    },
    view: {
        id: "attachments-macro.view",
        defaultMessage: "View"
    },
    properties: {
        id: "attachments-macro.properties",
        defaultMessage: "Properties"
    },
    deleteAttachment: {
        id: "attachments-macro.delete",
        defaultMessage: "Delete"
    },
    errorGeneric: {
        id: "attachments-macro.error-generic",
        defaultMessage: "Error retrieving attachments"
    },
    errorPageNotFound: {
        id: "attachments-macro.error-page-not-found",
        defaultMessage: "Item not found: {pageTitle}"
    },
    errorNoPagePermission: {
        id: "attachments-macro.error-no-page-permission",
        defaultMessage: "Restrictions have been applied that limit access to this content: {pageTitle}"
    },
    downloadAll: {
        id: "attachments-macro.download-all",
        defaultMessage: "Download All"
    },
    downloadAllDesc: {
        id: "attachments-macro.download-all-desc",
        defaultMessage: "Download all attachments"
    },
    loading: {
        id: "attachments-macro.loading",
        defaultMessage: "Loading attachments\u2026"
    },
    columnName: {
        id: "attachments-macro.column-name",
        defaultMessage: "File"
    },
    expandVersionHistory: {
        id: "attachments-macro.expand-version-history",
        defaultMessage: "Expand version history for {fileName}"
    },
    collapseVersionHistory: {
        id: "attachments-macro.collapse-version-history",
        defaultMessage: "Collapse version history for {fileName}"
    },
    columnModified: {
        id: "attachments-macro.column-modified",
        defaultMessage: "Modified"
    },
    columnAuthor: {
        id: "attachments-macro.column-author",
        defaultMessage: "Author"
    },
    columnExpandToggle: {
        id: "attachments-macro.column-expand-toggle",
        defaultMessage: "Expand attachment details"
    }
});
module.exports["i18n"] = $ada0102ecadc3b3d$export$a7357cdd1f0b0168;

});

parcelRegister("fUCKK", function(module, exports) {

var $2AVi4 = parcelRequire("2AVi4");


var $9wGTI = parcelRequire("9wGTI");


var $jMyy4 = parcelRequire("jMyy4");

const $d8595d0fc7bd685e$var$useIsAttachmentDownloadDisabledQuery = (0, $2AVi4.default);
const $d8595d0fc7bd685e$export$11481e5f9bc98634 = (action, contentId, spaceKey)=>({
        action: action,
        contentId: contentId,
        contentStatus: 'CURRENT',
        contentVersion: 1,
        spaceKey: spaceKey
    });
const $d8595d0fc7bd685e$export$f8ce0f983169a841 = ({ contentId: contentId, spaceKey: spaceKey, skip: skip })=>{
    const action = (0, $9wGTI.fg)('cc-dlp_split-attachment-dl-from-export-dsp') ? 'ATTACHMENT_DOWNLOAD' : 'PAGE_EXPORT';
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($d8595d0fc7bd685e$var$useIsAttachmentDownloadDisabledQuery, {
        variables: $d8595d0fc7bd685e$export$11481e5f9bc98634(action, contentId, spaceKey),
        context: {
            allowOnExternalPage: true
        },
        skip: skip,
        __callerPackage__: "data-security"
    });
    const allowedResp = data?.dataSecurityPolicy?.isActionEnabledForContent?.allowed;
    // Defaults to disabled if we don't have a definitive answer
    const isDisabled = allowedResp === undefined || allowedResp === null ? true : !allowedResp;
    return {
        isDisabled: isDisabled,
        loading: loading,
        error: error
    };
};
module.exports["useIsAttachmentDownloadDisabled"] = $d8595d0fc7bd685e$export$f8ce0f983169a841;

});

parcelRegister("2AVi4", function(module, exports) {
/**
 * @generated SignedSource<<ca3e4aaa86e273c539e67daa76dccb3d>>
 * @relayHash 978334c7a56389878fe12e353224c5fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b52b2cd2f09302e89f948c3933b5eded67abf62d74d6bcf7400ae8c36d1ed238
const $687cac4df14cb915$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "action"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentVersion"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "Confluence_dataSecurityPolicy",
            "kind": "LinkedField",
            "name": "dataSecurityPolicy",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "action",
                            "variableName": "action"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentStatus",
                            "variableName": "contentStatus"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentVersion",
                            "variableName": "contentVersion"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "DataSecurityPolicyDecision",
                    "kind": "LinkedField",
                    "name": "isActionEnabledForContent",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "action"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "allowed"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsAttachmentDownloadDisabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsAttachmentDownloadDisabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "978334c7a56389878fe12e353224c5fb",
            "id": "b52b2cd2f09302e89f948c3933b5eded67abf62d74d6bcf7400ae8c36d1ed238",
            "metadata": {},
            "name": "useIsAttachmentDownloadDisabledQuery",
            "operationKind": "query",
            "text": "query useIsAttachmentDownloadDisabledQuery($action:DataSecurityPolicyAction!,$contentId:ID!,$contentStatus:DataSecurityPolicyDecidableContentStatus!,$contentVersion:Int!,$spaceKey:String){dataSecurityPolicy{isActionEnabledForContent(action:$action,contentId:$contentId,contentStatus:$contentStatus,contentVersion:$contentVersion,spaceKey:$spaceKey){action,allowed}}}"
        }
    };
}();
$687cac4df14cb915$var$node.hash = "c2b35f4574dc5079df90541fabaaf6f9";
var $687cac4df14cb915$export$2e2bcd8739ae039 = $687cac4df14cb915$var$node;
module.exports["default"] = $687cac4df14cb915$export$2e2bcd8739ae039;

});

parcelRegister("bUIlA", function(module, exports) {
/**
 * Extract a value from the Confluence `Content.extensions` array.
 *
 * The AGG schema has NO standalone `type Attachment` — attachments are
 * `Content` nodes with `type: "attachment"`. File metadata like `fileSize`
 * and `mediaType` lives inside the generic `extensions: [KeyValueHierarchyMap]`
 * array rather than as first-class fields.
 *
 * See PROGRESS.md §27.1–27.2 and GRAPHQL_PLAN.md §0.3 for the schema rationale.
 *
 * Mirrors `confluence/next/packages/attachments-page/src/attachmentUtils.ts:27`
 * but with stricter null-tolerance to match the generated Relay types
 * (`{ readonly key: string | null; readonly value: string | null } | null`).
 *
 * @example
 *   const fileSize = Number(getExtensionValue(node.extensions, 'fileSize') ?? 0);
 *   const mediaType = getExtensionValue(node.extensions, 'mediaType') ?? '';
 */ const $c189e18d14f81dcb$export$223cab2cadce220 = (extensions, key)=>{
    if (!extensions) return null;
    const entry = extensions.find((e)=>e?.key === key);
    return entry?.value ?? null;
};
module.exports["getExtensionValue"] = $c189e18d14f81dcb$export$223cab2cadce220;

});

parcelRegister("8WOej", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iqehY = parcelRequire("iqehY");


var $9TA3F = parcelRequire("9TA3F");


var $9Jnyo = parcelRequire("9Jnyo");


var $gCdaE = parcelRequire("gCdaE");


var $1kVaD = parcelRequire("1kVaD");


var $67SYT = parcelRequire("67SYT");


var $5t27u = parcelRequire("5t27u");


var $cAa12 = parcelRequire("cAa12");


var $EhIdb = parcelRequire("EhIdb");


var $gCL8n = parcelRequire("gCL8n");


var $1rDre = parcelRequire("1rDre");


var $4C7IM = parcelRequire("4C7IM");


var $8B1YK = parcelRequire("8B1YK");


var $90EXt = parcelRequire("90EXt");


var $aeJll = parcelRequire("aeJll");


var $6lknI = parcelRequire("6lknI");


var $fxeqy = parcelRequire("fxeqy");


var $42Fpa = parcelRequire("42Fpa");


var $eziPO = parcelRequire("eziPO");


var $5Dz6O = parcelRequire("5Dz6O");


var $8If3N = parcelRequire("8If3N");


var $fGSwx = parcelRequire("fGSwx");

const $403c9cfb5b020557$export$c647cb0ee6e282fe = [
    'small',
    'medium'
];
const $403c9cfb5b020557$var$AttachmentFileExtensionMatchers = [
    {
        regexp: /\.(pdf)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($8B1YK))),
            (0, (/*@__PURE__*/$parcel$interopDefault($90EXt)))
        ]
    },
    {
        regexp: /\.(gif)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($EhIdb))),
            (0, (/*@__PURE__*/$parcel$interopDefault($gCL8n)))
        ]
    },
    {
        regexp: /\.(jpeg|jpg|png)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($1rDre))),
            (0, (/*@__PURE__*/$parcel$interopDefault($4C7IM)))
        ]
    },
    {
        regexp: /\.(xml|html|js|css|java|jar|war|ear)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($fxeqy))),
            (0, (/*@__PURE__*/$parcel$interopDefault($42Fpa)))
        ]
    },
    {
        regexp: /\.(zip|tar|gz|bz2|rar)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($iqehY))),
            (0, (/*@__PURE__*/$parcel$interopDefault($9TA3F)))
        ]
    },
    {
        regexp: /\.(xlt|xls|xlsm|xlsx|xlst)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($1kVaD))),
            (0, (/*@__PURE__*/$parcel$interopDefault($67SYT)))
        ]
    },
    {
        regexp: /\.(pptx|ppsx|potx|pot|ppt|pptm)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($aeJll))),
            (0, (/*@__PURE__*/$parcel$interopDefault($6lknI)))
        ]
    },
    {
        regexp: /\.(docx|dotx|doc|dot)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($8If3N))),
            (0, (/*@__PURE__*/$parcel$interopDefault($fGSwx)))
        ]
    },
    {
        regexp: /\.(wma|wmv|ram|mp3)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($9Jnyo))),
            (0, (/*@__PURE__*/$parcel$interopDefault($gCdaE)))
        ]
    },
    {
        regexp: /\.(mov|mpeg|mpg|mp4|avi)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($eziPO))),
            (0, (/*@__PURE__*/$parcel$interopDefault($5Dz6O)))
        ]
    }
];
const $403c9cfb5b020557$export$724dbd38c6f8ef0 = {
    'application/pdf': [
        (0, (/*@__PURE__*/$parcel$interopDefault($8B1YK))),
        (0, (/*@__PURE__*/$parcel$interopDefault($90EXt)))
    ],
    'image/gif': [
        (0, (/*@__PURE__*/$parcel$interopDefault($EhIdb))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gCL8n)))
    ],
    'image/jpeg': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1rDre))),
        (0, (/*@__PURE__*/$parcel$interopDefault($4C7IM)))
    ],
    'image/png': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1rDre))),
        (0, (/*@__PURE__*/$parcel$interopDefault($4C7IM)))
    ],
    'text/xml': [
        (0, (/*@__PURE__*/$parcel$interopDefault($fxeqy))),
        (0, (/*@__PURE__*/$parcel$interopDefault($42Fpa)))
    ],
    'text/html': [
        (0, (/*@__PURE__*/$parcel$interopDefault($fxeqy))),
        (0, (/*@__PURE__*/$parcel$interopDefault($42Fpa)))
    ],
    'text/css': [
        (0, (/*@__PURE__*/$parcel$interopDefault($fxeqy))),
        (0, (/*@__PURE__*/$parcel$interopDefault($42Fpa)))
    ],
    'text/javascript': [
        (0, (/*@__PURE__*/$parcel$interopDefault($fxeqy))),
        (0, (/*@__PURE__*/$parcel$interopDefault($42Fpa)))
    ],
    'text/plain': [
        (0, (/*@__PURE__*/$parcel$interopDefault($5t27u))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cAa12)))
    ],
    //NEED TO GIVE THIS AN ICON,
    'application/zip': [
        (0, (/*@__PURE__*/$parcel$interopDefault($iqehY))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9TA3F)))
    ],
    'application/x-zip': [
        (0, (/*@__PURE__*/$parcel$interopDefault($iqehY))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9TA3F)))
    ],
    'application/x-zip-compressed': [
        (0, (/*@__PURE__*/$parcel$interopDefault($iqehY))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9TA3F)))
    ],
    'application/java-archive': [
        (0, (/*@__PURE__*/$parcel$interopDefault($iqehY))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9TA3F)))
    ],
    'application/vnd.ms-excel': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1kVaD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($67SYT)))
    ],
    'application/vnd.ms-powerpoint': [
        (0, (/*@__PURE__*/$parcel$interopDefault($aeJll))),
        (0, (/*@__PURE__*/$parcel$interopDefault($6lknI)))
    ],
    'application/msword': [
        (0, (/*@__PURE__*/$parcel$interopDefault($8If3N))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fGSwx)))
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1kVaD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($67SYT)))
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1kVaD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($67SYT)))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
        (0, (/*@__PURE__*/$parcel$interopDefault($aeJll))),
        (0, (/*@__PURE__*/$parcel$interopDefault($6lknI)))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow': [
        (0, (/*@__PURE__*/$parcel$interopDefault($aeJll))),
        (0, (/*@__PURE__*/$parcel$interopDefault($6lknI)))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.template': [
        (0, (/*@__PURE__*/$parcel$interopDefault($aeJll))),
        (0, (/*@__PURE__*/$parcel$interopDefault($6lknI)))
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        (0, (/*@__PURE__*/$parcel$interopDefault($8If3N))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fGSwx)))
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template': [
        (0, (/*@__PURE__*/$parcel$interopDefault($8If3N))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fGSwx)))
    ],
    'application/x-shockwave-flash': [
        (0, (/*@__PURE__*/$parcel$interopDefault($5t27u))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cAa12)))
    ],
    //NEED TO GIVE THIS AN ICON
    'video/quicktime': [
        (0, (/*@__PURE__*/$parcel$interopDefault($eziPO))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5Dz6O)))
    ],
    'audio/x-ms-wma': [
        (0, (/*@__PURE__*/$parcel$interopDefault($9Jnyo))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gCdaE)))
    ],
    'audio/x-ms-wmv': [
        (0, (/*@__PURE__*/$parcel$interopDefault($9Jnyo))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gCdaE)))
    ],
    'video/mpeg': [
        (0, (/*@__PURE__*/$parcel$interopDefault($eziPO))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5Dz6O)))
    ],
    'audio/x-pn-realaudio': [
        (0, (/*@__PURE__*/$parcel$interopDefault($9Jnyo))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gCdaE)))
    ],
    'application/vnd.rn-realmedia': [
        (0, (/*@__PURE__*/$parcel$interopDefault($5t27u))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cAa12)))
    ],
    //NEED TO GIVE THIS AN ICON
    'audio/mpeg': [
        (0, (/*@__PURE__*/$parcel$interopDefault($9Jnyo))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gCdaE)))
    ],
    'video/x-msvideo': [
        (0, (/*@__PURE__*/$parcel$interopDefault($eziPO))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5Dz6O)))
    ],
    'video/mp4': [
        (0, (/*@__PURE__*/$parcel$interopDefault($eziPO))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5Dz6O)))
    ],
    'audio/mp4': [
        (0, (/*@__PURE__*/$parcel$interopDefault($9Jnyo))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gCdaE)))
    ],
    'audio/mp3': [
        (0, (/*@__PURE__*/$parcel$interopDefault($9Jnyo))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gCdaE)))
    ],
    default: [
        (0, (/*@__PURE__*/$parcel$interopDefault($5t27u))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cAa12)))
    ]
};
const $403c9cfb5b020557$export$2063a590c0694ba8 = (extensions)=>{
    if (!extensions || !Array.isArray(extensions)) return null;
    const mediaType = extensions.find(({ key: key })=>key === 'mediaType');
    return mediaType ? mediaType.value : null;
};
class $403c9cfb5b020557$export$edc04f92718bbea4 extends (0, $cozmU.PureComponent) {
    render() {
        const { mediaType: mediaType, label: label, size: size } = this.props;
        const iconArray = this.getIconArray();
        const sizeIndex = $403c9cfb5b020557$export$c647cb0ee6e282fe.indexOf(size ?? 'medium') || 0;
        const icon = iconArray[sizeIndex];
        const testId = `attachment-icon-${mediaType?.replace('/', '-') ?? 'unknown'}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(icon, {
            size: // @ts-expect-error FIXME: `size` is not an acceptable prop here
            size,
            label: label,
            testId: testId
        });
    }
    constructor(...args){
        super(...args);
        this.getIconArray = ()=>{
            const { mediaType: mediaType, title: title } = this.props;
            if (mediaType && $403c9cfb5b020557$export$724dbd38c6f8ef0[mediaType]) return $403c9cfb5b020557$export$724dbd38c6f8ef0[mediaType];
            if (title) {
                const extension = $403c9cfb5b020557$var$AttachmentFileExtensionMatchers.find((extensionMatcher)=>{
                    const matches = extensionMatcher.regexp.exec(title);
                    return !!matches && matches.length > 0;
                });
                if (extension) return extension.icon;
            }
            return $403c9cfb5b020557$export$724dbd38c6f8ef0['default'];
        };
    }
}
module.exports["AttachmentIcon"] = $403c9cfb5b020557$export$edc04f92718bbea4;

});

parcelRegister("4vaoM", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a85e440150ad6165$export$761f49b4caa7a581 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "JXn3W",
    name: "EditLabelDialogLoader",
    loader: async ()=>(await (parcelRequire("keIhE"))).EditLabelDialogComponent
});
module.exports["EditLabelDialogLoader"] = $a85e440150ad6165$export$761f49b4caa7a581;

});

parcelRegister("keIhE", function(module, exports) {

let $ebb77746597fc5fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ebb77746597fc5fc$var$load("6wr18"),
    $ebb77746597fc5fc$var$load("ffEVr"),
    $ebb77746597fc5fc$var$load("ky9au"),
    $ebb77746597fc5fc$var$load("4fYzp"),
    $ebb77746597fc5fc$var$load("953Uz"),
    $ebb77746597fc5fc$var$load("jigcs"),
    $ebb77746597fc5fc$var$load("1fnbu")
]).then(()=>parcelRequire('m0wkE'));

});

parcelRegister("a6t12", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kNIYN = parcelRequire("kNIYN");


var $9DHhW = parcelRequire("9DHhW");


var $hSs5g = parcelRequire("hSs5g");


var $9zU5G = parcelRequire("9zU5G");


var $9wGTI = parcelRequire("9wGTI");


var $jyPfN = parcelRequire("jyPfN");


var $jlIaF = parcelRequire("jlIaF");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $gqqjz = parcelRequire("gqqjz");


var $5XsiK = parcelRequire("5XsiK");

parcelRequire("6OL2O");
var $5t3NX = parcelRequire("5t3NX");

parcelRequire("dD7ks");
var $4N3op = parcelRequire("4N3op");


var $bedVD = parcelRequire("bedVD");


var $l7wqU = parcelRequire("l7wqU");


var $4GlQ9 = parcelRequire("4GlQ9");


var $bumSD = parcelRequire("bumSD");


var $4qzKl = parcelRequire("4qzKl");


var $gj42z = parcelRequire("gj42z");

const $3d0f3ea3171aff68$var$i18n = (0, $kSwu1.defineMessages)({
    viewProfile: {
        id: "profile.card.viewProfile",
        defaultMessage: "View profile"
    }
});
const $3d0f3ea3171aff68$export$98f80b73da7beaf4 = ({ push: push, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: ()=>(0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId).then(push),
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, '', (0, $jlIaF.CONTEXT_PATH))
    });
const $3d0f3ea3171aff68$export$4f94384af0327320 = ({ navigate: navigate, url: url })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: navigate,
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: url
    });
const $3d0f3ea3171aff68$export$d114163e55e8b2c5 = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, userId: userId, followedUsers: followedUsers })=>{
    const followed = !!(userId && followedUsers?.includes(userId));
    return {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        }),
        id: 'feed-follow-user',
        callback: getToggleFollowUser(userId, followed, 'profileCard'),
        shouldRender: (userData)=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId && userData?.status === 'active'
    };
};
const $3d0f3ea3171aff68$export$ba990269c861f33b = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, followedRef: followedRef, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l7wqU.FeedFollowAction), {
            userId: userId
        }),
        id: 'feed-follow-user',
        callback: ()=>getToggleFollowUser(userId, followedRef.current, 'profileCard')(),
        shouldRender: ()=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId
    });
const $3d0f3ea3171aff68$export$59abd6feb7dc8540 = ({ position: position = 'bottom-start', userId: userId, isAnonymous: isAnonymous = false, canViewProfile: canViewProfile = true, children: children, trigger: trigger = 'hover', fullName: fullName, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, ariaLabel: ariaLabel, agent: agent })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const { userId: loggedInUserId, cloudId: cloudId, featureFlags: featureFlags, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const reportingLines = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'LANDING'
    });
    const getReportingLinesUserProfile = (clickedUserId)=>(0, $5t3NX.getNavigateToTeamsApp)(orgId || '', {
            type: 'USER',
            payload: {
                userId: clickedUserId
            }
        });
    const userProfile = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId || ''
        }
    });
    const reportingLinesProfileUrl = (0, $5XsiK.isTeamsAppEnabled)() ? reportingLines.href : `${0, $jlIaF.CONTEXT_PATH}/people`;
    const { feedConfigError: feedConfigError, followedUsers: followedUsers, getToggleFollowUser: getToggleFollowUser, mutationError: mutationError, renderFeedFollow: renderFeedFollow } = (0, $4GlQ9.useFeedFollow)();
    const viewProfileAction = (0, $cozmU.useMemo)(()=>(0, $5XsiK.isTeamsAppEnabled)() ? $3d0f3ea3171aff68$export$4f94384af0327320({
            navigate: userProfile.onNavigate,
            url: userProfile.href
        }) : $3d0f3ea3171aff68$export$98f80b73da7beaf4({
            push: push,
            userId: userId
        }), [
        push,
        userId,
        userProfile
    ]);
    const followUserAction = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$d114163e55e8b2c5({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            userId: userId,
            followedUsers: followedUsers
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId,
        followedUsers
    ]);
    // The card snapshots the actions, so the follow callback reads the latest follow state
    // from this ref (updated on every render) instead of a value captured when the action
    // was built. This keeps repeated follow/unfollow toggles in the correct direction.
    const followedRef = (0, $cozmU.useRef)(false);
    followedRef.current = !!(userId && followedUsers?.includes(userId));
    const followUserActionNext = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$ba990269c861f33b({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            followedRef: followedRef,
            userId: userId
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId
    ]);
    // Should display profile?
    if (isAnonymous || !canViewProfile || !userId || !loggedInUserId || !hasViewUserProfilePermission) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    const reportingLinesClickCallback = (clickedUserId_0)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'profileCardWrapper',
                action: 'clicked',
                actionSubject: 'viewProfile',
                actionSubjectId: 'userProfileCard',
                attributes: {
                    clickTarget: 'userReportingLine'
                }
            }
        }).fire();
        if ((0, $5XsiK.isTeamsAppEnabled)()) {
            getReportingLinesUserProfile(clickedUserId_0).onNavigate();
            return false;
        }
        if (window.self !== window.top) window.open((0, $4qzKl.getAtlassianPeopleProfileUrl)(clickedUserId_0, '', (0, $jlIaF.CONTEXT_PATH)), '_blank', 'noreferrer');
        else (0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(clickedUserId_0).then(push, ()=>{});
    };
    if ((0, $9wGTI.fg)('people-teams_migrate-user-profile-card')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
        feedConfigError: feedConfigError,
        mutationError: mutationError,
        showErrorFlag: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9zU5G.UserProfileCardWithTrigger), {
        cloudId: cloudId,
        orgId: orgId || '',
        userId: userId,
        viewerId: loggedInUserId,
        placement: position,
        trigger: trigger,
        actions: [
            followUserActionNext
        ],
        agent: agent ? {
            ...agent,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags)
        } : undefined,
        testId: "profileCardTrigger"
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            showErrorFlag: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSs5g.default), {
            cloudId: cloudId,
            userId: userId,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
            position: position,
            trigger: trigger,
            actions: [
                viewProfileAction,
                followUserAction
            ],
            reportingLinesProfileUrl: reportingLinesProfileUrl,
            onReportingLinesClick: (user)=>reportingLinesClickCallback(user.accountIdentifier),
            addFlag: (flag)=>flags.showFlag(flag),
            prepopulatedData: {
                fullName: fullName
            },
            disabledAriaAttributes: disabledAriaAttributes,
            onVisibilityChange: onVisibilityChange,
            offset: offset,
            testId: "profileCardTrigger",
            viewingUserId: loggedInUserId,
            ...disabledAriaAttributes ? {} : {
                ariaLabel: ariaLabel
            }
        }, children)));
};
module.exports["ProfileCardWrapper"] = $3d0f3ea3171aff68$export$59abd6feb7dc8540;

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $eW61a = parcelRequire("eW61a");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    return (0, $eW61a.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("dD7ks", function(module, exports) {
$parcel$export(module.exports, "useNavigateToTeamsApp", () => (parcelRequire("4N3op")).useNavigateToTeamsApp);

var $4N3op = parcelRequire("4N3op");


});

parcelRegister("4N3op", function(module, exports) {

var $eW61a = parcelRequire("eW61a");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");

const $bf6b29a56d69bf9f$export$520a42ab062954ec = (navActionPayload, shouldOpenInSameTab)=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    return (0, $eW61a.navigateToTeamsApp)({
        push: push,
        hostProduct: 'confluence',
        orgId: orgId,
        cloudId: cloudId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["useNavigateToTeamsApp"] = $bf6b29a56d69bf9f$export$520a42ab062954ec;

});

parcelRegister("l7wqU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");

const $460a3972eab8fd69$export$38809e1c08e05a16 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { userId: userId } = t0;
    const { followedUsers: followedUsers } = (0, $4GlQ9.useFeedFollow)();
    let t1;
    if ($[0] !== followedUsers || $[1] !== userId) {
        t1 = userId && followedUsers?.includes(userId);
        $[0] = followedUsers;
        $[1] = userId;
        $[2] = t1;
    } else t1 = $[2];
    const followed = !!t1;
    let t2;
    if ($[3] !== followed) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        });
        $[3] = followed;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["FeedFollowAction"] = $460a3972eab8fd69$export$38809e1c08e05a16;

});

parcelRegister("jJK3p", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $jyPfN = parcelRequire("jyPfN");


var $cPER9 = parcelRequire("cPER9");


var $4qzKl = parcelRequire("4qzKl");


var $a6t12 = parcelRequire("a6t12");


var $5XsiK = parcelRequire("5XsiK");

parcelRequire("dD7ks");
var $4N3op = parcelRequire("4N3op");

const $5c1fbd48d7d200d4$var$linkStyles = (0, $buxP3.xcss)({
    textDecoration: 'underline',
    display: 'inline-block',
    cursor: 'pointer'
});
const $5c1fbd48d7d200d4$var$i18n = (0, $kSwu1.defineMessages)({
    profileLinkName: {
        id: "profile.link.name",
        defaultMessage: "{fullName} profile"
    }
});
const $5c1fbd48d7d200d4$export$a2a4245643e0242b = (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { userId: userId, fullName: fullName, isAnonymous: t1, onUserLinkClick: onUserLinkClick, referralSource: referralSource, className: className, style: style, behavior: t2, position: t3, offset: offset, ariaLabel: ariaLabel, isUnderlinedByDefault: t4 } = t0;
    const isAnonymous = t1 === undefined ? false : t1;
    const behavior = t2 === undefined ? "link" : t2;
    const position = t3 === undefined ? "bottom-start" : t3;
    const isUnderlinedByDefault = t4 === undefined ? true : t4;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const intl = (0, $kSwu1.useIntl)();
    const t5 = userId ?? "";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            type: "USER",
            payload: {
                userId: t5
            }
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const { href: teamsAppPersonProfileUrl } = (0, $4N3op.useNavigateToTeamsApp)(t6);
    let t7;
    if ($[2] !== ariaLabel || $[3] !== behavior || $[4] !== className || $[5] !== fullName || $[6] !== intl || $[7] !== isAnonymous || $[8] !== isUnderlinedByDefault || $[9] !== offset || $[10] !== onUserLinkClick || $[11] !== position || $[12] !== referralSource || $[13] !== style || $[14] !== teamsAppPersonProfileUrl || $[15] !== userId) {
        t7 = ()=>{
            if (behavior === "card") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: isAnonymous,
                userId: userId,
                position: position,
                offset: offset,
                ariaLabel: ariaLabel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                style: style,
                xcss: $5c1fbd48d7d200d4$var$linkStyles
            }, fullName));
            else {
                const linkStyle = {
                    ...style,
                    ...isUnderlinedByDefault ? {
                        textDecoration: "underline"
                    } : {}
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cPER9.PeopleLink), {
                    target: "_blank",
                    onClick: onUserLinkClick,
                    href: (0, $5XsiK.isTeamsAppEnabled)() ? teamsAppPersonProfileUrl : (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, referralSource),
                    className: className,
                    style: linkStyle,
                    "data-testid": "profile-link",
                    "aria-label": ariaLabel || intl.formatMessage($5c1fbd48d7d200d4$var$i18n.profileLinkName, {
                        fullName: fullName
                    })
                }, fullName);
            }
        };
        $[2] = ariaLabel;
        $[3] = behavior;
        $[4] = className;
        $[5] = fullName;
        $[6] = intl;
        $[7] = isAnonymous;
        $[8] = isUnderlinedByDefault;
        $[9] = offset;
        $[10] = onUserLinkClick;
        $[11] = position;
        $[12] = referralSource;
        $[13] = style;
        $[14] = teamsAppPersonProfileUrl;
        $[15] = userId;
        $[16] = t7;
    } else t7 = $[16];
    const renderNameComponent = t7;
    let t8;
    if ($[17] !== fullName || $[18] !== hasViewUserProfilePermission || $[19] !== isAnonymous || $[20] !== renderNameComponent || $[21] !== userId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isAnonymous || !userId || userId === "" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "profile.anonymous.name",
            defaultMessage: "Anonymous"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hasViewUserProfilePermission ? renderNameComponent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, fullName)));
        $[17] = fullName;
        $[18] = hasViewUserProfilePermission;
        $[19] = isAnonymous;
        $[20] = renderNameComponent;
        $[21] = userId;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
};
module.exports["ProfileLink"] = $5c1fbd48d7d200d4$export$a2a4245643e0242b;

});

parcelRegister("cPER9", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $8lYIw = parcelRequire("8lYIw");


var $jlIaF = parcelRequire("jlIaF");


var $5XsiK = parcelRequire("5XsiK");

const $6a5a2957e3d32f84$export$43aa0d4f5c176033 = (props)=>{
    const $ = (0, $bDgLe.c)(10);
    let children;
    let href;
    let otherProps;
    let to;
    if ($[0] !== props) {
        ({ href: href, to: to, children: children, ...otherProps } = props);
        $[0] = props;
        $[1] = children;
        $[2] = href;
        $[3] = otherProps;
        $[4] = to;
    } else {
        children = $[1];
        href = $[2];
        otherProps = $[3];
        to = $[4];
    }
    const url = to || href;
    const path = url && url.indexOf("/") !== 0 ? `/${url}` : url;
    const destination = !path.startsWith((0, $jlIaF.CONTEXT_PATH)) ? `${0, $jlIaF.CONTEXT_PATH}${path}` : path;
    const t0 = (0, $5XsiK.isTeamsAppEnabled)() ? url : destination;
    let t1;
    if ($[5] !== children || $[6] !== otherProps || $[7] !== t0 || $[8] !== to) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
            href: t0,
            to: to,
            ...otherProps
        }, children);
        $[5] = children;
        $[6] = otherProps;
        $[7] = t0;
        $[8] = to;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
};
$6a5a2957e3d32f84$export$43aa0d4f5c176033.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string
};
module.exports["PeopleLink"] = $6a5a2957e3d32f84$export$43aa0d4f5c176033;

});

parcelRegister("2NFTR", function(module, exports) {

let $20a0a8d2e8da2be2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $20a0a8d2e8da2be2$var$load("78ESn").then(()=>parcelRequire('jC6cD'));

});

parcelRegister("90na9", function(module, exports) {

let $68e614cb900dbd27$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $68e614cb900dbd27$var$load("Wowvf"),
    $68e614cb900dbd27$var$load("6sDJC")
]).then(()=>parcelRequire('2Qk1i'));

});

parcelRegister("eATLT", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");


var $1NBp8 = parcelRequire("1NBp8");

const $dc31057420aa5644$export$6aee0ce422e62102 = (labelName, spaceKey)=>{
    if (spaceKey) return (0, $1NBp8.LABELLED_CONTENT).toUrl({
        spaceKey: spaceKey,
        labelName: encodeURIComponent(labelName)
    });
    return `${0, $jlIaF.CONTEXT_PATH}/label/${encodeURIComponent(labelName)}`;
};
module.exports["buildLabelUrl"] = $dc31057420aa5644$export$6aee0ce422e62102;

});

parcelRegister("aJ4wx", function(module, exports) {

let $0203e5a3d28d9f92$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0203e5a3d28d9f92$var$load("bi0bE").then(()=>parcelRequire('l8uTh'));

});


//# sourceMappingURL=AttachmentsMacroRenderer.c2f9032c.js.map
